export default __webpack_public_path__ + "static/media/nonIndexxTokens.06b9b306.svg";